export const TRANSLATION_GROUP_CHANGE_HISTORY = Symbol('change-history');
